import {
  entityReducerMap,
  IEntityState,
} from '../entity-data/entity-data.reducer';
import {
  ActionsEnum,
  DeleteFromTmpCache,
  SetInTmpCache,
} from './document-data.actions';
import { extend } from 'lodash';
import { createSelector } from '@ngrx/store';

// state interfaces
export interface IDocumentState extends IEntityState {
  tmpCache: { [key: string]: any };
}

export function documentReducerMap<T extends IDocumentState>() {
  return {
    ...entityReducerMap<T>(),
    [ActionsEnum.SET_IN_TMP_CACHE]: function (
      state: T,
      { payload }: SetInTmpCache
    ): T {
      const { key, value } = payload;
      const tmpCache = {
        ...state.tmpCache,
        [key]: value,
      };

      return extend({}, state, { tmpCache });
    },
    [ActionsEnum.DELETE_FROM_TMP_CACHE]: function (
      state: T,
      { payload }: DeleteFromTmpCache
    ): T {
      const tmpCache = state.tmpCache;
      delete tmpCache[payload.key];

      return extend({}, state, { tmpCache });
    },
  };
}

// selector helpers
export function getTmpCache<T extends IDocumentState>(selectFeature) {
  return createSelector(selectFeature, (state: T) => state.tmpCache);
}
